import { GtmScript } from 'utils/analytics/GTMScript';
import { useAnalyticsInitialize } from 'utils/analytics/useAnalyticsInitialize';

export const Analytics = () => {
  const shouldLoadGtmScript = useAnalyticsInitialize();

  return shouldLoadGtmScript ? <GtmScript /> : null;
};
